module.exports = __webpack_public_path__ + "static/assets/5f036b63ec5808bf8e0047586dd3d373.svg";